// ============================================================
// FILE: resources/js/plugins/security.js
// USPATIH GO — Frontend Security Plugin
//
// Membaca konfigurasi dari window.SECURITY_CONFIG yang
// di-inject oleh Blade layout via config/security.php
//
// Saat DevTools terbuka: UI tetap normal. Hanya panel Elements
// yang diisi node decoy tersembunyi (acak), tanpa wipe DOM asli.
// ============================================================

(function () {
  const cfg = window.SECURITY_CONFIG || {};

  // ---- 1. Nonaktifkan klik kanan ----------------------------
  if (cfg.disableRightClick) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();

      if (cfg.rightClickMessage) {
        if (typeof window.toast === 'function') {
          window.toast(cfg.rightClickMessage, 'warning', 3000);
        } else {
          showSecurityTooltip(e, cfg.rightClickMessage);
        }
      }
      return false;
    });
  }

  // ---- 2. Nonaktifkan seleksi teks --------------------------
  if (cfg.disableTextSelect) {
    document.addEventListener('selectstart', function (e) {
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea') return true;
      e.preventDefault();
      return false;
    });

    const style = document.createElement('style');
    style.textContent = `
      body *:not(input):not(textarea):not([contenteditable="true"]) {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  // ---- 3. Nonaktifkan copy / cut ----------------------------
  if (cfg.disableCopy) {
    document.addEventListener('copy', function (e) {
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea') return true;
      e.preventDefault();
      return false;
    });

    document.addEventListener('cut', function (e) {
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea') return true;
      e.preventDefault();
      return false;
    });

    document.addEventListener('keydown', function (e) {
      const isCtrl = e.ctrlKey || e.metaKey;
      const tag = e.target?.tagName?.toLowerCase();
      const isForm = tag === 'input' || tag === 'textarea';

      if (isCtrl && !isForm) {
        const blocked = ['c', 'x', 'u', 's'];
        if (blocked.includes(e.key.toLowerCase())) {
          e.preventDefault();
          return false;
        }
      }
    });
  }

  // ---- 4. DevTools: UI tetap normal, Elements diacak ----------
  // Point revisi #10: jangan wipe DOM / ganti layar dengan kode acak.
  // Inject decoy tersembunyi (aria-hidden, off-screen) agar panel
  // Elements berisik, sementara layout mobile/desktop tetap seperti biasa.
  if (cfg.disableDevtools) {
    document.addEventListener('keydown', function (e) {
      const isCtrlShift = (e.ctrlKey || e.metaKey) && e.shiftKey;
      if (
        e.key === 'F12' ||
        (isCtrlShift && ['i', 'j', 'c'].includes(e.key.toLowerCase()))
      ) {
        e.preventDefault();
        return false;
      }
    });

    const obfuscate = cfg.obfuscateOnDevtools !== false;
    if (obfuscate) {
      let decoyRoot = null;
      let scrambleTimer = null;
      let lastOpen = false;

      function randHex(n) {
        const chars = 'abcdef0123456789';
        let out = '';
        for (let i = 0; i < n; i++) out += chars[(Math.random() * chars.length) | 0];
        return out;
      }

      function randIdent(len) {
        const a = 'abcdefghijklmnopqrstuvwxyz';
        const b = a + '0123456789_';
        let s = a[(Math.random() * a.length) | 0];
        for (let i = 1; i < len; i++) s += b[(Math.random() * b.length) | 0];
        return s;
      }

      function ensureDecoyRoot() {
        if (decoyRoot && document.body.contains(decoyRoot)) return decoyRoot;

        decoyRoot = document.getElementById('_usp_obf_root');
        if (!decoyRoot) {
          decoyRoot = document.createElement('div');
          decoyRoot.id = '_usp_obf_root';
          // Sisip di akhir body — tidak mengganti konten asli
          document.body.appendChild(decoyRoot);
        }

        decoyRoot.setAttribute('data-protected', randHex(32));
        decoyRoot.setAttribute('aria-hidden', 'true');
        decoyRoot.setAttribute('role', 'presentation');
        // Invisible to layout / screen readers / pointer
        decoyRoot.style.cssText = [
          'position:absolute',
          'left:-10000px',
          'top:0',
          'width:1px',
          'height:1px',
          'overflow:hidden',
          'opacity:0',
          'pointer-events:none',
          'clip:rect(0,0,0,0)',
          'clip-path:inset(50%)',
          'white-space:nowrap',
          'z-index:-1',
          'contain:strict',
        ].join(';');

        return decoyRoot;
      }

      function buildDecoyFragment(count) {
        const frag = document.createDocumentFragment();
        const tags = ['div', 'section', 'span', 'nav', 'aside', 'main', 'article', 'ul', 'li', 'form'];

        for (let i = 0; i < count; i++) {
          if (i % 7 === 0) {
            const script = document.createElement('script');
            script.type = 'application/json';
            script.setAttribute('data-k', randHex(16));
            script.textContent = JSON.stringify({
              [randIdent(5)]: '0x' + randHex(6),
              fn: randIdent(7),
            });
            frag.appendChild(script);
            continue;
          }

          const tag = tags[(Math.random() * tags.length) | 0];
          const el = document.createElement(tag);
          el.id = 'x' + randHex(8);
          el.className = `${randIdent(4)}_${randHex(6)} ${randIdent(5)}`;
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('data-k', randHex(16));
          el.setAttribute('style', `--v:${randHex(4)}`);
          el.appendChild(document.createComment(randHex(20)));
          if (i % 4 === 0) el.textContent = randHex(12);
          frag.appendChild(el);
        }

        return frag;
      }

      function refreshDecoys() {
        const root = ensureDecoyRoot();
        root.setAttribute('data-protected', randHex(32));
        root.replaceChildren(buildDecoyFragment(36 + ((Math.random() * 24) | 0)));
      }

      function startScramble() {
        refreshDecoys();
        if (!scrambleTimer) {
          scrambleTimer = setInterval(refreshDecoys, 1800);
        }
      }

      function stopScramble() {
        if (scrambleTimer) {
          clearInterval(scrambleTimer);
          scrambleTimer = null;
        }
      }

      function isDevtoolsOpen() {
        const threshold = 160;
        const wide = window.outerWidth - window.innerWidth > threshold;
        const tall = window.outerHeight - window.innerHeight > threshold;
        if (wide || tall) return true;

        let opened = false;
        const probe = new Image();
        Object.defineProperty(probe, 'id', {
          get() {
            opened = true;
            return 'usp';
          },
        });
        try {
          // eslint-disable-next-line no-console
          console.log('%c', probe);
          console.clear?.();
        } catch (_) { /* ignore */ }
        return opened;
      }

      setInterval(function () {
        const open = isDevtoolsOpen();
        if (open) {
          startScramble();
        } else if (lastOpen && !open) {
          stopScramble();
        }
        lastOpen = open;
      }, 900);
    }
  }

  // ---- 5. Nonaktifkan drag & drop gambar --------------------
  if (cfg.disableImageDrag) {
    document.addEventListener('dragstart', function (e) {
      if (e.target?.tagName?.toLowerCase() === 'img') {
        e.preventDefault();
        return false;
      }
    });
  }

  // ---- 6. Nonaktifkan print ---------------------------------
  if (cfg.disablePrint) {
    document.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'p') {
        e.preventDefault();
        return false;
      }
    });

    const printStyle = document.createElement('style');
    printStyle.textContent = '@media print { body { display: none !important; } }';
    document.head.appendChild(printStyle);
  }

  function showSecurityTooltip(mouseEvent, message) {
    const old = document.getElementById('_sec_tooltip');
    if (old) old.remove();

    const tip = document.createElement('div');
    tip.id = '_sec_tooltip';
    tip.textContent = message;
    tip.style.cssText = `
      position: fixed;
      left: ${Math.min(mouseEvent.clientX + 10, window.innerWidth - 280)}px;
      top:  ${Math.min(mouseEvent.clientY + 10, window.innerHeight - 50)}px;
      background: rgba(30,41,59,.92);
      color: #fff;
      font-size: 13px;
      font-family: sans-serif;
      padding: 8px 14px;
      border-radius: 10px;
      z-index: 99999;
      pointer-events: none;
      box-shadow: 0 4px 16px rgba(0,0,0,.2);
      max-width: 260px;
      line-height: 1.4;
    `;
    document.body.appendChild(tip);
    setTimeout(() => tip.remove(), 2500);
  }
})();
